import {
  Box,
  Flex,
  FormDateInput,
  FormRadioSelection,
  FormTextField,
  Text,
} from '@shared/components';

import { QSetReviewFormUserSelection } from '../qset-review-form-user-selection';

export default function ReviewQsetTaskDetailsFormFields() {
  return (
    <>
      <FormTextField
        name='taskDetails.name'
        label='Task Name'
        placeholder='กรุณากรอก Task Name'
        required
      />

      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          borderRadius: theme.shape.rounded(2),
          border: `1px solid ${theme.palette.grey[300]}`,
          bgcolor: theme.palette.grey[50],
          p: theme.spacing(4),
          gap: theme.spacing(4),
        })}
      >
        <FormRadioSelection
          name='taskDetails.assignTo'
          label='Assignment Type'
          required
          options={[
            {
              label: (
                <Text variant='body1Semibold'>
                  Delegated Assignment:{' '}
                  <Text component='span'>
                    มอบหมายงานให้ผู้ดูแล โดยผู้ดูแลสามารถส่งต่อ/มอบหมายต่อให้ผู้ตรวจสอบได้
                  </Text>
                </Text>
              ),
              value: 'DELEGATED',
            },
            {
              label: (
                <Text variant='body1Semibold'>
                  Direct Assignment:{' '}
                  <Text component='span'>มอบหมายงานให้ผู้ตรวจสอบโดยตรง ไม่สามารถส่งต่อได้</Text>
                </Text>
              ),
              value: 'DIRECT',
            },
          ]}
        />
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <Box sx={{ flex: 1 }}>
            <QSetReviewFormUserSelection name='taskDetails.assignee' />
          </Box>
          <Box sx={{ flex: 1 }}>
            <FormDateInput
              name='taskDetails.dueDate'
              label='Due Date'
              minDate={new Date()}
              placeholder='กรุณาเลือก Due Date'
              required
            />
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
